import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo

import RnetlogoSmall from "assets/logo/R-Nets-N-knots-logo.png";
// import Rnetlogo from "assets/logo/R-Nets-N-knots-logo.png";
import Rnetlogo from "assets/logo/R-Nets-sticky-logo.png";
import metaphiLogo from 'assets/logo/metaphi_logo.png';

//Import Components
import { Button, Container } from "react-bootstrap";
import HorizontalLayout from "./HorizontalLayout";
import TwoColumnLayout from "./TwoColumnLayout";
import VerticalLayout from "./VerticalLayouts/index";

const Sidebar = ({ layoutType }: any) => {
  const location = useLocation(); // <-- Detect current route

  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay && verticalOverlay[0]) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <Link to={process.env.PUBLIC_URL + "/"} className="logo logo-dark">
            <span className="logo-sm">
              <img src={Rnetlogo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={Rnetlogo} alt="" height="22" />
            </span>
          </Link>

          <Link to={process.env.PUBLIC_URL + "/"} className="logo logo-light">
            {/* <span className="logo-lg">
              <img src={Rnetlogo} alt="" height="45" />
            </span> */}
            <span className="logo-lg">
              <img className="mt-2" src={RnetlogoSmall} alt="" height="50" width="140" />
            </span>

            <span className="logo-sm ">
              <img src={metaphiLogo} alt="" height="50" width="70" />
            </span>
            {/* <span className="logo-lg">
              {" "}
              <img src={Rnetlogo} alt="" height="22" />
            </span> */}
          </Link>
          <Button
            variant="link"
            size="sm"
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn p-0 fs-3xl header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </Button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout layoutType={layoutType} />
              </ul>
            </Container>
          </div>
        ) : layoutType === "twocolumn" ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  {/* Pass currentPath to VerticalLayout for automatic menu expansion */}
                  <VerticalLayout
                    layoutType={layoutType}
                    currentPath={location.pathname}
                  />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
